import React, { useState } from 'react';
import { API_BASE_URL } from '../../config'; // Importar URL base dinámica
import { Button, TextInput, Label, Spinner, Alert } from 'flowbite-react';

const CloverAuth = () => {
  const [merchantId, setMerchantId] = useState('');
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAuthSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    if (!merchantId || !code || !email) {
      setMessage('Todos los campos son obligatorios.');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/callback`, { // Usar URL dinámica desde config.js
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          merchant_id: merchantId,
          code,
          nombre: name || 'Cliente Sin Nombre',
          email,
        }),
      });
  
      const result = await response.json();
  
      if (response.status === 401) {
        setMessage('Error 401: No autorizado. El código es inválido o ha expirado.');
      } else if (response.status === 400) {
        setMessage(`Error 400: Solicitud incorrecta. ${result.error || 'Revisa los parámetros.'}`);
      } else if (response.ok) {
        setMessage(`Éxito: ${result.mensaje}`);
      } else {
        setMessage(`Error: ${result.error || 'Algo salió mal'}`);
      }
    } catch (error) {
      console.error('Error al enviar datos:', error);
      setMessage('Error al conectar con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-md mx-auto bg-white shadow-md rounded-lg">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">
        Configuración del Token de Clover
      </h1>

      {message && (
        <Alert color={message.includes('Éxito') ? 'success' : 'failure'}>
          {message}
        </Alert>
      )}

      <form onSubmit={handleAuthSubmit}>
        <div className="mb-4">
          <Label htmlFor="name" value="Nombre" />
          <TextInput
            id="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Nombre del cliente"
          />
        </div>

        <div className="mb-4">
          <Label htmlFor="email" value="Email" />
          <TextInput
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email del cliente"
            required
          />
        </div>

        <div className="mb-4">
          <Label htmlFor="merchantId" value="Merchant ID" />
          <TextInput
            id="merchantId"
            type="text"
            value={merchantId}
            onChange={(e) => setMerchantId(e.target.value)}
            placeholder="ID del comerciante"
            required
          />
        </div>

        <div className="mb-4">
          <Label htmlFor="code" value="Código de Autorización" />
          <TextInput
            id="code"
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Código de autorización"
            required
          />
        </div>

        <Button type="submit" className="w-full" disabled={loading}>
          {loading ? (
            <>
              <Spinner className="mr-2" /> Cargando...
            </>
          ) : (
            'Guardar Cliente'
          )}
        </Button>
      </form>
    </div>
  );
};

export default CloverAuth;
